import React from 'react'

const Scorers = ({
  scorer = '',
  commentator = ''
}) => {
  const htmlString = []

  if(scorer) {
    htmlString.push(`Scorer: <span>${scorer}</span>`)
  }

  if(commentator) {
    htmlString.push(`Commentator: <span>${commentator}</span>`)
  }
  return (
    <p className="commentator-scorer" dangerouslySetInnerHTML={{ __html: htmlString.length &&  htmlString.join(' | ') || null }} />
  )
}

export default Scorers



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/Scorers.jsx